import "./Indicators.css";

export function Indicators({ children, className }) {
  return (
    <div className={["Indicators", className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}

export function Indicator({ children }) {
  return <div className="Indicator">{children}</div>;
}

export function IndicatorIconWrapper({ children, style, className }) {
  return (
    <div
      className={["IndicatorIconWrapper", className].filter(Boolean).join(" ")}
      style={style}
    >
      {children}
    </div>
  );
}

export function IndicatorContainer({ children }) {
  return <div className="IndicatorContainer">{children}</div>;
}

export function IndicatorText({ children, bold, small, div = false }) {
  const className = ["IndicatorText", bold && "bold", small && "small"]
    .filter(Boolean)
    .join(" ");

  if (div) return <div className={className}>{children}</div>;
  return (
    <p className={className} title={children}>
      {children}
    </p>
  );
}
